import React from "react"

import * as style from "./HoverMenu.module.scss"

const HoverMenu = ({
  children, right = false, wide = false, center = false, noPadding = false,
}) => (
  <nav className={style.menu} data-right={right} data-wide={wide} data-center={center} data-no-padding={noPadding}>
    {children}
  </nav>
)

export default HoverMenu
